import React, { useEffect } from "react";

import phone from "./Phone.svg";
import link from "./Chat.svg";
import { useTranslation, Trans } from "react-i18next";
import i18n from "./i18n";
import { PageProps } from "./interfaces/ComponentProps";
import { getServiceMailByCountryCode, getServicePhoneByCountryCode } from "./helpers/CountryHelper";

export const SupportLinksHelp = ({lang, country}: PageProps) => {

  const { t } = useTranslation(['supportLinksHelp']);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    i18n.changeLanguage(lang);
  }, [lang])

  const serviceMail = getServiceMailByCountryCode(country);
  const servicePhone = getServicePhoneByCountryCode(country);

  if (!serviceMail && !servicePhone) {
    return <></>;
  }

  return (
    <div className="App_center">
      <p className="Service-Desk">
        <Trans t={t} i18nKey="header" components={{ em: <em />, p: <p />, strong: <strong /> }} />
      </p>
      <div className="App_li_parent">
        <div className="App_li">
          <p className="App_p1">
            <img src={phone} className="App-img-service" alt="phone" />
            <Trans t={t} i18nKey="servicePhone" values={{servicePhone: servicePhone, servicePhoneShow: servicePhone.slice(3).match(/.{1,2}/g)?.join(' ') }} components={{ a: <a />, em: <em />, p: <p />, strong: <strong /> }} />
          </p>
          <p className="App_p2">
            <img src={link} className="App-img-service" alt="link" />
            <Trans t={t} i18nKey="serviceMail" values={{serviceMail: serviceMail}} components={{ a: <a />, em: <em />, p: <p />, strong: <strong /> }} />
          </p>
        </div>
      </div>
    </div>
  );
}
